<template>
  <Toast
    :open="toastMessage.message !== ''"
    :variant="toastMessage?.type"
    placement="top-right"
    :class="['max-[400px]:!w-[98%] max-[400px]:!right-1 mt-[60px] 2xl:!w-[500px] z-50', toastClasses]"
  >
    <div class="flex items-center justify-between w-full">
      <Icon :name="toastIcon" class="mr-2" />
      <p class="text-sm font-normal flex flex-1">{{ toastMessage.message }}</p>
      <Icon name="x-solid-icon" class="mt-[3px] cursor-pointer" @click="deleteToastMessage" />
    </div>
  </Toast>
</template>

<script lang="ts">
import { Icon } from "@toruslabs/vue-components/Icon";
import { Toast } from "@toruslabs/vue-components/Toast";
import { defineComponent } from "vue";

import { userModule } from "@/store/index";

import { TOAST_TYPES, ToastMessage } from "../../utils/enums";

export default defineComponent({
  name: "Toaster",
  components: { Icon, Toast },
  data: () => ({
    timeoutTimer: 0,
  }),
  computed: {
    toastMessage(): ToastMessage {
      return userModule.toastMessage;
    },
    toastMessageType() {
      return this.toastMessage.type || "default";
    },
    toastIcon() {
      if (this.toastMessage.type === TOAST_TYPES.SUCCESS) return "check-circle-solid-icon";
      if (this.toastMessage.type === TOAST_TYPES.ERROR) return "x-circle-solid-icon";
      return "information-circle-solid-icon";
    },
    toastClasses(): string {
      if (this.toastMessageType === "success") {
        return "!text-app-green-900 !bg-app-green-100 !border-app-green-200";
      }
      if (this.toastMessageType === "info") {
        return "!text-app-primary-900 !bg-app-primary-100 !border-app-primary-200";
      }
      if (this.toastMessageType === "danger") {
        return "!text-app-red-900 !bg-app-red-100 !border-app-red-200";
      }
      return "!text-app-gray-900 !bg-app-gray-100 dark:!bg-app-dark-surface2 !border-app-gray-200";
    },
  },
  watch: {
    toastMessage(val: ToastMessage): void {
      if (val.message) {
        this.timeoutTimer = window.setTimeout(() => {
          this.deleteToastMessage();
        }, 5000);
      }
    },
  },
  methods: {
    deleteToastMessage(): void {
      userModule.setToastMessage({ message: "" });
      clearTimeout(this.timeoutTimer);
    },
  },
});
</script>

<style lang="scss" scoped></style>
